import React from 'react';
import Verified from '/fallbacks/verified.svg';

const TestimonialsCard = ({
	rating,
	description,
	reviewerImg,
	reviewerName,
	country,
	title,
	daysAgo,
	countryImg,
	reviewLabel,
}) => {
	const cleanCheck =
		(window.isMobile == false && window.msg?.enable_clean_version_in_desktop) ||
		(window.isMobile == true && window.msg?.enable_clean_version_in_mobile);

	const directCheck = window.msg?.clean_checkout_if_direct_customer && window.directCheck;

	const enableCleanVersion = directCheck | cleanCheck;

	return (
		<section className="carousel__slide">
			<div className="carousel__slideProfile">
				<img
					className="carousel__slideProfileImg mon-img-40-h"
					src={reviewerImg}
					alt="alt"
					style={{ position: 'relative', top: '2px' }}
				/>
				<div className="carousel__verifiedName">
					<span>{reviewerName}</span>
					<span style={{ backgroundImage: `url('${Verified}')` }}></span>
					<span>{reviewLabel}</span>
				</div>
				<div className="carousel__countryBox" style={{ position: 'relative', top: '-2px' }}>
					<img className="carousel__countryImg" alt="alt" src={countryImg} />
					<span className="carousel__countryName">{country}</span>
				</div>
				<div className="carousel__dateRatingBox">
					<img
						className="carousel__rating"
						src={`${window.template_root}/templates/checkout-pages/V3/src/public/stars/${
							enableCleanVersion ? 'safe' : 'full'
						}/star-${rating}.svg`}
						alt="star"
					/>
					<span className="carousel__date" data-days-ago={daysAgo}></span>
				</div>
			</div>
			<h3 className="carousel__slideHeading">{title}</h3>
			<p className="carousel__slideText">{description}</p>
		</section>
	);
};

export default TestimonialsCard;
